import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { TenderState } from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";

function TenderWonLostResultComponent({ tenderState, reasonForLoss }: { tenderState: TenderState, reasonForLoss?: string | null}) {
  const { t } = useTranslation(["components"]);

  return (
    <>
      {tenderState === TenderState.Won && (
        <Card className="border-green-500">
          <CardHeader>
            <CardTitle className="text-green-500">
              {t("components:tendersubmission.won.title")}
            </CardTitle>
            <CardDescription>
              {t("components:tendersubmission.won.description")}
            </CardDescription>
          </CardHeader>
        </Card>
      )}
      {tenderState === TenderState.Lost && (
        <Card className="border-red-500">
          <CardHeader>
            <CardTitle className="text-red-500 text">
              {t("components:tendersubmission.lost.title")}
            </CardTitle>
            <CardDescription>
              {t("components:tendersubmission.lost.description")}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {reasonForLoss}
          </CardContent>
        </Card>
      )}
    </>
  );
}

export default TenderWonLostResultComponent;
